// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ToqJ","tabsBox":"styles_tabsBox__2TOsb","createButton":"styles_createButton__3D6Lt"};